// React
import React from 'react'
import classNames from 'classnames'
// Styles
import useStyles from './ToppingBox.styles'
// Utils
import { formatCurrency } from '../../utils/CurrencyUtils'
// Components
import Conditional from '../common/conditional'
import CustomCheckbox from '../common/custom-checkbox'
import MenuToppingDeactivationOptions from '../menu-topping-deactivation-options'
import CustomEyeSwitch from '../common/custom-eye-switch'

export const selectorTypes = {
  CHECKBOX: 'CHECKBOX',
  DEACTIVATION_OPTIONS: 'DEACTIVATION_OPTIONS',
  EYE: 'EYE',
}

const getSelector = (
  isAvailable,
  onChange,
  selectorType,
  toppingCategoryId,
  toppingId,
  topping,
  deactivatedItemId,
  setDeactivatedItemId,
) => {
  switch (selectorType) {
    case selectorTypes.CHECKBOX:
      return (
        <CustomCheckbox
          checked={isAvailable}
          onChange={onChange}
          value={isAvailable}
        />
      )
    case selectorTypes.DEACTIVATION_OPTIONS:
      return (
        <MenuToppingDeactivationOptions
          toppingCategoryId={toppingCategoryId}
          toppingId={toppingId}
          isAvailable={isAvailable}
          topping={topping}
          deactivatedItemId={deactivatedItemId}
          setDeactivatedItemId={setDeactivatedItemId}
        />
      )
    case selectorTypes.EYE:
    default:
      return <CustomEyeSwitch active={isAvailable} onClick={onChange} />
  }
}

const ToppingBox = ({
  classes,
  onChange,
  selectorPropertyName,
  selectorType,
  showTitle,
  topping,
  deactivatedItemId,
  setDeactivatedItemId,
}) => {
  const componentClasses = useStyles()
  const selector = getSelector(
    topping[selectorPropertyName],
    onChange,
    selectorType,
    topping.toppingCategoryId,
    topping.id,
    topping,
    deactivatedItemId,
    setDeactivatedItemId,
  )

  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <Conditional
        if={showTitle && !!topping.title && topping.title.trim() !== ''}
      >
        <div
          className={classNames(
            componentClasses.titleContainer,
            classes.titleContainer,
          )}
        >
          <span className={classNames(componentClasses.title, classes.title)}>
            {topping.title}
          </span>
        </div>
      </Conditional>
      <div className={classNames(componentClasses.box, classes.box)}>
        <Conditional
          if={!!topping.description && topping.description.trim() !== ''}
        >
          <span className={classNames(componentClasses.name, classes.name)}>
            {topping.description}
          </span>
        </Conditional>
        <Conditional if={!!topping.price}>
          <span
            className={classNames(componentClasses.price, classes.price)}
          >{`${formatCurrency(topping.price)}`}</span>
        </Conditional>
        {selector}
      </div>
    </div>
  )
}

ToppingBox.defaultProps = {
  classes: {},
  onChange: () => {},
  products: [],
  selectorPropertyName: 'activated',
  selectorType: selectorTypes.DEACTIVATION_OPTIONS,
  showTitle: false,
  topping: {},
  toppingCategories: [],
  title: '',
}
export default ToppingBox
